import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromGeoLocationActions from '../+state/actions/geo-location.actions';

@Injectable({ providedIn: 'root' })
export class GeoLocationFacade {
  constructor(private store: Store) {}

  storeInputValues(skipGeoLocationApi: boolean) {
    this.store.dispatch(
      fromGeoLocationActions.StoreGeoLocationInputValues({ skipGeoLocationApi })
    );
  }

  loadGeoLocation() {
    this.store.dispatch(fromGeoLocationActions.LoadGeoLocation());
  }
}
